import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { cookieUtils } from '../utils/cookies';

const ResultsPage = () => {
  const [studentData, setStudentData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const data = cookieUtils.getStudentData();
    if (!data || data.status !== 'completed') {
      navigate('/');
      return;
    }
    setStudentData(data);
  }, [navigate]);


  if (!studentData) {
    return (
      <div className="container">
        <div className="card">
          <div style={{ textAlign: 'center' }}>
            <h2>Loading results...</h2>
          </div>
        </div>
      </div>
    );
  }

  const percentage = Math.round((studentData.score / 30) * 100);
  const isPassing = percentage >= 70;

  return (
    <div className="container">
      <div className="card">
        <div className="results-page">
          <h1 style={{ marginBottom: '30px', color: '#333' }}>
            Quiz Results
          </h1>

          <div className="score-display">
            {studentData.score} / 30
          </div>

          <div className="percentage-display">
            {percentage}%
          </div>

          <div style={{ 
            fontSize: '18px', 
            color: '#000000',
            marginBottom: '30px',
            fontWeight: 'bold'
          }}>
            {isPassing ? 'Congratulations! You passed!' : 'Keep studying! You can do better!'}
          </div>

          <div style={{ 
            background: '#ffffff', 
            padding: '20px', 
            borderRadius: '8px',
            border: '1px solid #000000',
            marginBottom: '30px'
          }}>
            <h3 style={{ marginBottom: '15px', color: '#000000' }}>Quiz Summary</h3>
            <p><strong>Student Name:</strong> {studentData.name}</p>
            <p><strong>Score:</strong> {studentData.score} out of 30 questions</p>
            <p><strong>Percentage:</strong> {percentage}%</p>
            <p><strong>Status:</strong> {studentData.status}</p>
            {studentData.endTime && (
              <p><strong>Completed:</strong> {new Date(studentData.endTime).toLocaleString()}</p>
            )}
          </div>

          <div className="navigation">
            <button 
              className="btn"
              onClick={() => window.location.href = '/'}
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default ResultsPage;
